import http from 'core/services/http';
import Config from 'core/config';

class TrainingService {
  static getTrainings(userId) {
    return http.get(`${Config.apiUrl}/personnel/${userId}/testmodule`);
  }

  static completeTask(userId, taskId) {
    return http.put(`${Config.apiUrl}/personnel/${userId}/trainingtask/${taskId}/complete`);
  }
}

export default TrainingService;
